// extracted by mini-css-extract-plugin
export default {"h1":"PureHeading_h1__2VEBK","h2":"PureHeading_h2__DdCB2","h4":"PureHeading_h4__JxT9y","h5":"PureHeading_h5__IFDi7","h6":"PureHeading_h6__lTxC8","h3":"PureHeading_h3__BTT9K"};